<div class="d-flex flex-column note-list-container">
  <div class="d-flex flex-row align-items-center note-title">
    <span>{{'note.title' | translate}}</span>
    <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.note' | translate"></achoo-icon-tooltip>
  </div>
  <div class="list-notes">
    <div *ngFor="let note of notes">
      <inline-edit-note [note]="note"
                        (addNoteSucessCallback)="afterCreateOrUpdateNote($event)"
                        (deletingNoteCallback)="deletedNote($event)">
      </inline-edit-note>
    </div>
    <div *ngIf="showSuggestion">
      <inline-edit-note [note]="sampleNote" [isSampleNote]="true"></inline-edit-note>
    </div>
    <div class="add-note-box">
      <button *ngIf="allowToAddNewNote" class="badge mention add-new-mention" (click)="onAddNewNote()" [disabled]="isReadOnly">
        <img src="../../../../assets/images/Add_Icon.svg" width="8" height="8"/>
      </button>
      <inline-edit-note #createNewNoteRef
                        *ngIf="!allowToAddNewNote"
                        [note]="newNote"
                        (addNoteSucessCallback)="afterCreateOrUpdateNote($event)"
                        (blurCallback)="cancelAddingNote()">
      </inline-edit-note>
    </div>
  </div>
  <div class="fade-out-content">

  </div>
</div>
<achoo-popup #NotificationNoteErrorProcessing
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}"
             (acceptCallback)="closeNotification()"
             (cancelCallback)="closeNotification()">
  <span>{{'note.error_message' | translate }}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer/add-notes/add-notes.component.html